import React from 'react';
import { connect } from 'react-redux';

import Input from '@components/Input';

import Panel from '@scene/objects/panel';
import { setPanelHeight } from '@reducers/options/panel/actions';
import { unitLabel, unitTransform } from '@services/helper.service';
import { defaultUnits } from '@config';
import { Tooltip } from '@components/Tippy';
import { APP_TOOLTIPS } from '../../../../../src/texts/tooltips';

const Ly = props => {
  if (props.panelType !== Panel.types.CIRCLE && props.panelType !== Panel.types.CUSTOM) {
    return (
      <Tooltip content={APP_TOOLTIPS.TOOLTIP_BASE_PLATE_LY.Content}>
      <Input
        prefix="Ly ="
        postfix={unitLabel(props.unit)}
        id="height"
        type="number"
        minValue={0}
        className="base-plate__input_block"
        disabled={props.predefinedBasePlate && props.predefinedBasePlate.isPredefinedBasePlate}
        value={props.height}
        onUpdate={value => {
          props.setHeight(value, props.unit);
        }}
      />
      </Tooltip>
    );
  }

  return null;
};

const mapState = state => {
  const unit = state.main.units.distance;

  return {
    panelType: state.options.panel.type,
    height: unitTransform(state.options.panel.height || 0).from(defaultUnits.DISTANCE).to(unit),
    unit,
    predefinedBasePlate: state.selectors.application[state.main.appType].predefinedBasePlate
  };
};

const mapDispatch = dispatch => ({
  setHeight: (value, unit) => dispatch(setPanelHeight(unitTransform(+value, false).from(unit).to(defaultUnits.DISTANCE))),
});

export default connect(mapState, mapDispatch)(Ly);



// WEBPACK FOOTER //
// ./src/views/Dimension/components/BasePlate/Ly.js